import { render } from "./CartProductModal.vue?vue&type=template&id=35017e1a"
import script from "./CartProductModal.vue?vue&type=script&lang=js"
export * from "./CartProductModal.vue?vue&type=script&lang=js"

import "./CartProductModal.vue?vue&type=style&index=0&id=35017e1a&lang=scss"
script.render = render

export default script